import React from 'react';

const PublicContext = React.createContext(null);

export const PublicContextValue = {
	isPublicMode: true,
};

export default PublicContext;
